module.exports = __webpack_public_path__ + "static/media/6_School of the animals_ES.61b26ea3.txt";